import React from "react";
import { IconLink } from "@rhumbix/rmbx_design_system_design_tokens";
import Label from "../Label";
import { colorMiscGray90, spacingS } from "@rhumbix/rmbx_design_system_design_tokens";
export const DocumentLink = ({ title, url }) => (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
    React.createElement("div", { style: { flex: "3" } },
        React.createElement(Label, { style: { marginTop: spacingS } }, title)),
    React.createElement("div", { style: {
            flex: "1",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "right",
        } },
        React.createElement("a", { href: url, target: "_blank", rel: "noreferrer noopener" },
            React.createElement(IconLink, { height: "16px", width: "16px", style: { marginBottom: "-2px", marginRight: spacingS, color: colorMiscGray90 } }),
            React.createElement("span", { style: { textDecoration: "underline", color: colorMiscGray90 } }, "Learn More")))));
export default DocumentLink;
